import {
  REQUEST_MEDIA_FILES_SUCCESS,
  REQUEST_MEDIA_FILES_FAILURE,
  CLOUD_FILE_UPLOAD_SUCCESS,
  DELETE_FILES_SUCCESS,
  GET_MEDIA_FOLDERS_FAILURE,
  GET_MEDIA_FOLDERS_SUCCESS,
  SET_MEDIA_FILES_STORE
} from '../constants/actionTypes';

const INITIAL_STATE = { numOfFiles: 0, usedSpace: 0, media: [], mediafolders:[], storemedia:[], errors: null };

export default function fileManager(state = INITIAL_STATE, action) {
  switch (action.type) {
    case REQUEST_MEDIA_FILES_SUCCESS:
    case DELETE_FILES_SUCCESS:
      return {
        ...state,
        numOfFiles: action.payload.data.num_rows,
        usedSpace: action.payload.data.used_space,
        media: action.payload.data.media_list,
        errors: null
      };
    case CLOUD_FILE_UPLOAD_SUCCESS:
      return {
        ...state,
        numOfFiles: action.payload.data.number_of_files,
        usedSpace: action.payload.data.used_space,
        metaData: action.payload.data.meta_info,
        cloudType: action.payload.data.user_type,
        errors: null
      }
    case REQUEST_MEDIA_FILES_FAILURE:
      return { ...INITIAL_STATE, errors: action.payload.response && action.payload.response.data.errors };
    case GET_MEDIA_FOLDERS_SUCCESS: 
      return { ...state, mediafolders: action.payload.data, errors: null };  
    case SET_MEDIA_FILES_STORE: 
      return { ...state, storemedia: action.payload, errors: null };
    case GET_MEDIA_FOLDERS_FAILURE:
      return { ...state, mediafolders: [], errors: null };
      default:
      return state;
  }
}
